<div class="app-card__top-line"></div>
<div class="app-card__content">
  <ng-content select="[app-card-indicators-icon]"></ng-content>
  <ng-content select="[app-card-indicators-change]"></ng-content>
  <ng-content select="[app-card-indicators-value]"></ng-content>
  <ng-content select="[app-card-indicators-label]"></ng-content>
</div>
